import { connect } from 'react-redux';

function mapStateToProps(state) {
  const {
    restricted: {
      _session: { currentOwnerGuid: ownerGuid },
    },
  } = state;
  return { ownerGuid };
}

export default function(component) {
  return connect(mapStateToProps)(component);
}



// WEBPACK FOOTER //
// ./src/connectHOCs/Sessions/currentSession/ownerGuid.js